






































































































































































import { Component, Prop, Vue, Mixins } from 'vue-property-decorator'
import PageLayout from '@/components/page/PageLayout.vue'
import listMixins from '@/mixins/list'
import ReconciliationApi from '@/api/reconciliation'
import { debounce } from '@/utils/util'
const debounceSync = debounce(300)

@Component({
	name: 'ReconciliationList',
	components: {
		PageLayout,
	},
})
export default class ReconciliationList extends Mixins(listMixins) {
	private columns: object = [
		{
			title: '序号',
			dataIndex: 'order',
			align: 'center',
			width: 60,
			scopedSlots: { customRender: 'order' },
		},
		{
			title: '已对账订单数',
			dataIndex: 'statedOrderNum',
			align: 'center',
			width: 120,
		},
		{
			title: '账单金额',
			dataIndex: 'finalSettleAmount',
			align: 'center',
			width: 100,
		},
		{
			title: '机构名称',
			dataIndex: 'institutionName',
			align: 'center',
			width: 210,
		},
		{
			title: '账单起始日期',
			dataIndex: 'startTime',
			align: 'center',
			width: 180,
			scopedSlots: { customRender: 'timeFormatter' },
		},
		{
			title: '账单截止日期',
			dataIndex: 'endTime',
			align: 'center',
			width: 180,
			scopedSlots: { customRender: 'timeFormatter' },
		},
		{
			title: '同步次数',
			dataIndex: 'synchTimes',
			align: 'center',
			width: 100,
		},
		{
			title: '操作',
			dataIndex: 'canSynch',
			align: 'center',
			width: 80,
			scopedSlots: { customRender: 'action' },
		},
	]
	private data: any[] = []
	private resynchModalVisible: boolean = false
	private resynchLoading: boolean = false
	private resynchForm: any = ''
	private resynchByOrderModalVisible: boolean = false
	private resynchByOrderLoading: boolean = false
	private resynchByOrderForm: any = ''

	public getList() {
		let values = this.searchForm.getFieldsValue()
		values.institutionId = (
			(values.company && String(values.company.value)) ||
			''
		).trim()
		values.company && delete values.company

		return ReconciliationApi.getList({
			...values,
			pageSize: this.pageSize,
			pageNum: this.current,
		}).then((res: any) => {
			const data = res.data
			this.data = data.retList
			this.total = data.count
		})
	}

	private invokeSynch(row: { statementId: string; institutionId: string }) {
		debounceSync(() => {
			let hide = this.$message.loading('正在同步', 0)
			ReconciliationApi.synch({
				statementId: row.statementId,
				institutionId: row.institutionId,
			})
				.then(res => {
					this.getList()
					this.$message.success('同步完成')
				})
				.finally(() => {
					hide && hide()
				})
		})
	}

	public initCompanyTree() {
		// 覆盖 companySearchTree mixin中的方法
		this.$store.dispatch('setting/initPartnerAndCompany').then((res: any) => {
			this.currentTree = this.$store.state.setting.partnerAndCompanyTree
			this.setCompanyAsTree()
		})
	}

	private showResynchModal() {
		console.log('showResynchModal called')
		// 先显示弹窗
		this.resynchModalVisible = true
		
		
	}

	private handleCancelResynch() {
		console.log('handleCancelResynch called')
		this.resynchLoading = false
		this.resynchModalVisible = false
	}

	private handleResynch() {
		console.log('handleResynch called')
		this.resynchForm.validateFields((err: any, values: any) => {
			console.log('validateFields callback', err, values)
			if (!err) {
				this.resynchLoading = true
				// 如果已经是字符串格式，直接使用；如果是 moment 对象，则格式化
				const startDate = typeof values.startDate === 'string' 
					? values.startDate 
					: values.startDate.format('YYYY-MM-DD')
				console.log('Calling resynch API with startDate:', startDate)
				ReconciliationApi.resynch({ startDate })
					.then((res: any) => {
						console.log('resynch success', res)
						this.$message.success('重推业财成功')
						this.resynchModalVisible = false
						this.getList()
					})
					.catch((error: any) => {
						console.error('resynch error', error)
						this.$message.error('重推业财失败')
					})
					.finally(() => {
						console.log('resynch finally')
						this.resynchLoading = false
					})
			}
		})
	}

	private showResynchByOrderModal() {
		this.resynchByOrderModalVisible = true
	}

	private handleCancelResynchByOrder() {
		this.resynchByOrderLoading = false
		this.resynchByOrderModalVisible = false
	}

	private handleResynchByOrder() {
		this.resynchByOrderForm.validateFields((err: any, values: any) => {
			if (!err) {
				this.resynchByOrderLoading = true
				ReconciliationApi.resynchByOrder(values.orderNo)
					.then((res: any) => {
						this.$message.success('按订单重推成功')
						this.resynchByOrderModalVisible = false
						this.getList()
					})
					.catch(() => {
						this.$message.error('按订单重推失败')
					})
					.finally(() => {
						this.resynchByOrderLoading = false
					})
			}
		})
	}

	public activated() {
		this.getList()
	}

	public created() {
		this.resynchForm = this.$form.createForm(this)
		this.resynchByOrderForm = this.$form.createForm(this)
		this.getList()
	}
}
